import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	connected: false,
	connecting: false,
	error: null,
};

const socketSlice = createSlice({
	name: 'socket',
	initialState,
	reducers: {
		socketConnecting: (state) => {
			state.connecting = true;
			state.error = null;
		},
		socketConnected: (state) => {
			state.connected = true;
			state.connecting = false;
			state.error = null;
		},
		socketDisconnected: (state) => {
			state.connected = false;
			state.connecting = false;
		},
		socketError: (state, action) => {
			state.error = action.payload ?? null;
			state.connecting = false;
		},
	},
});

export const { socketConnecting, socketConnected, socketDisconnected, socketError } = socketSlice.actions;
export default socketSlice.reducer;
